import { gql } from '@apollo/client';

const schema = {
  assign: {
    name: "createLabsUser",
    serviceName: "labadmin",
    query: gql`
      mutation createLabsUser(
        $lab_id: String
        $unit_id: String
        $user_ids: [String]!
        $role_id: String!
        $details: String
      ) {
        createLabsUser(
          lab_id: $lab_id
          unit_id: $unit_id
          user_ids: $user_ids
          role_id: $role_id
          details: $details
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
